import { toast } from 'react-toastify'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function handlerError(error: any, defaultMessage?: string) {
  if (
    (error?.message || (error?.messages?.length > 0 && error?.messages)) &&
    !error?.stack
  ) {
    if (error?.messages?.length > 0) {
      error?.messages.map((e: string) => {
        toast.error(e, {
          className: 'text-break',
          autoClose: false
        })
      })
    } else {
      toast.error(error?.message, {
        className: 'text-break',
        autoClose: false
      })
    }
  } else {
    defaultMessage
      ? toast.error(defaultMessage, {
          className: 'text-break',
          autoClose: false
        })
      : toast.error('Não foi possível!', {
          className: 'text-break',
          autoClose: false
        })
  }
}
